if (!customElements.get('slideshow-component')) {
  customElements.define('slideshow-component', class SlideshowComponent extends SliderComponent {
    constructor() {
      super();
    }

    init() {
      super.init();
      this.setupSlideVideos();
      this.sliderControlWrapper = this.querySelector('.slider-buttons');
      this.enableSliderLooping = true;
      this.autoplayButtonQuerySelector = '.slideshow__autoplay';
      this.autoPlayPausedClass = 'slideshow__autoplay--paused';
  
      if (!this.sliderControlWrapper) return;
  
      if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
  
      this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
      this.setSlideVisibility();

      this.querySelectorAll('.banner__price').forEach(ele => {
        ele.innerHTML = Shopify.showPrice(ele.dataset.price * 1);
      });
    }
  
    update() {
      super.update();
      const activeSlide = this.querySelector('.slideshow__slide.active');
      if(activeSlide) activeSlide.classList.remove('active');
      this.querySelector(`.slideshow__slide:nth-child(${this.currentPage})`).classList.add('active');
      if(this.prevButton) {
        this.prevButton.removeAttribute('disabled');
      }
    }
  
    setupSlideVideos() {
      this.slideVideos = this.querySelectorAll('.slideshow__video');
      if (!this.slideVideos.length) return;
      this.slideVideos.forEach((video) => {
        // Guarantee muted inline playback so browsers allow autoplay (incl. iOS Safari).
        video.muted = true;
        video.setAttribute('playsinline', '');
        this.playVideo(video);
      });
      // Re-sync playback when the desktop/mobile media swaps (e.g. tablet rotation).
      window.matchMedia('(min-width: 750px)').addEventListener('change', this.syncVideoPlayback.bind(this));
    }

    syncVideoPlayback() {
      if (this.sliderControlWrapper && this.currentPage) {
        this.setSlideVisibility();
      } else {
        this.slideVideos.forEach((video) => {
          if (video.offsetParent === null) video.pause();
          else this.playVideo(video);
        });
      }
    }

    playVideo(video) {
      // Skip videos hidden for the current viewport (e.g. small-hide when a mobile
      // image is shown instead) so they don't download/decode needlessly.
      if (video.offsetParent === null) return;
      const playPromise = video.play();
      // force autoplay for safari
      if (playPromise !== undefined) playPromise.catch(() => {});
    }

    setSlideVisibility() {
      this.sliderItemsToShow.forEach((item, index) => {
        const linkElements = item.querySelectorAll('a');
        const videos = item.querySelectorAll('.slideshow__video');
        if (index === this.currentPage - 1) {
          if (linkElements.length) linkElements.forEach(button => {
            button.removeAttribute('tabindex');
          });
          item.setAttribute('aria-hidden', 'false');
          item.removeAttribute('tabindex');
          videos.forEach(video => this.playVideo(video));
        } else {
          if (linkElements.length) linkElements.forEach(button => {
            button.setAttribute('tabindex', '-1');
          });
          item.setAttribute('aria-hidden', 'true');
          item.setAttribute('tabindex', '-1');
          videos.forEach(video => video.pause());
        }
      });
    }
  
    play() {
      super.play();
      if(this.sliderAutoplayButton) {
        this.sliderAutoplayButton.classList.remove(this.autoPlayPausedClass);
        this.sliderAutoplayButton.querySelector('.slideshow__progress__path').getAnimations().forEach((anim) => {
          anim.cancel();
          anim.play();
        });
      }
    }

    pause() {
      super.pause();
      if(this.sliderAutoplayButton) {
        this.sliderAutoplayButton.classList.add(this.autoPlayPausedClass);
        this.sliderAutoplayButton.querySelector('.slideshow__progress__path').getAnimations().forEach((anim) => {
          anim.pause();
        });
      }
    }
  });
}